import React from "react";
import { Select } from "antd";
import styles from "./style.module.scss";
const { Option } = Select;

const SingleSelect = ({
  options,
  reset,
  placeholder,
  defaultValue,
  selectedOptions,
  setSelectedOptions,
  disableMenu,
  width,
  height,
  allowClearSelection,
  optionsLoading,
  popupStyling,
}) => {
  const handleSelection = (value) => {
    const selected = options.find((option) => option.value === value);
    setSelectedOptions(selected);
  };
  return (
    <div
      className={popupStyling ? styles.popupFilters : styles.filters}
      style={
        height || width ? { width: `${width}px`, height: `${height}px` } : {}
      }
    >
      {reset ? (
        <Select
          onChange={handleSelection}
          placeholder={placeholder}
          value={selectedOptions ? selectedOptions.value : defaultValue}
          listHeight={160}
          disabled={disableMenu}
          showSearch
          style={
            width || height
              ? { width: `${width}px`, height: `${height}px` }
              : {}
          }
          loading={optionsLoading}
          allowClear={allowClearSelection}
          optionFilterProp="title"
        >
          {options?.map((option) => (
            <Option key={option.id} value={option.value} title={option.label}>
              {option.img && <img src={option.img} width={22} height={22} />}{" "}
              <span className={styles.optionLabel}>{option.label}</span>
            </Option>
          ))}
        </Select>
      ) : (
        <Select
          onChange={handleSelection}
          placeholder={placeholder}
          value={selectedOptions ? selectedOptions.value : defaultValue}
          listHeight={160}
          disabled={disableMenu}
          showSearch
          loading={optionsLoading}
          style={
            width || height
              ? { width: `${width}px`, height: `${height}px` }
              : {}
          }
          allowClear={allowClearSelection}
          optionFilterProp="title"
        >
          {options?.map((option) => (
            <Option key={option.id} value={option.value} title={option.label}>
              {option.img && <img src={option.img} width={22} height={22} />}{" "}
              <span className={styles.optionLabel}>{option.label}</span>
            </Option>
          ))}
        </Select>
      )}
    </div>
  );
};

export default SingleSelect;
